'use client';
import { useTranslations } from 'next-intl';
import type React from 'react';

import GlassSegmentedControl from '@cineamo/composables/src/ticket-booking/GlassSegmentedControl';
import type { SeatMapViewMode } from '@cineamo/composables/src/ticket-booking/seat-map-view-mode';

const MODES: SeatMapViewMode[] = ['2D', '3D'];

const SeatMapViewToggle: React.FC<{
    mode: SeatMapViewMode;
    onChange: (mode: SeatMapViewMode) => void;
    className?: string;
}> = ({ mode, onChange, className }) => {
    const t = useTranslations('tickets');
    return (
        <GlassSegmentedControl
            options={MODES.map((m) => ({ value: m, label: t(m === '2D' ? 'seat-map-view-2d' : 'seat-map-view-3d') }))}
            value={mode}
            onChange={onChange}
            label={t('seat-map-view-label')}
            caption={t('seat-map-view-caption')}
            className={className}
        />
    );
};

export default SeatMapViewToggle;
